import type React from 'react'

import img from '../../assets/figma/93-3630/1885b0771cf20b395288777becdf56a8fda55789.svg'
import img1 from '../../assets/figma/93-3630/d24f99c9fc3e6c24a169b1f98830595c84596fd6.svg'

export interface ButtonProps {
  label?: string
  leftIcon?: boolean
  rightIcon?: boolean
  counter?: boolean
  leftIcon1?: React.ReactNode | null
  rightIcon1?: React.ReactNode | null
  size?: 'Large'
  style?: 'Primary' | 'Tertiary'
  state?: 'Focused' | 'Active'
  onClick?: () => void
}

export const Button: React.FC<ButtonProps> = ({
  label = 'Button',
  leftIcon = true,
  rightIcon = true,
  counter: _counter = true,
  leftIcon1 = null,
  rightIcon1 = null,
  size = 'Large',
  style = 'Primary',
  state = 'Focused',
  onClick,
}) => {
  if (size === 'Large' && style === 'Primary' && state === 'Active') {
    return (
      <button
        type="button"
        className="bg-blue-500 text-white relative rounded-[12px] size-full cursor-pointer"
        onClick={onClick}
        data-name="Size=Large, Style=Primary, State=Active"
        data-node-id="93:3631"
      >
        <div className="box-border content-stretch flex gap-2 items-center justify-center overflow-clip px-5 py-3 relative size-full">
          <div
            className="content-stretch flex gap-2 items-center justify-center relative shrink-0"
            data-name="Block"
            data-node-id="93:3632"
          >
            {leftIcon &&
              (leftIcon1 || (
                <div
                  className="overflow-clip relative shrink-0 size-6"
                  data-name="Icon"
                  data-node-id="93:3633"
                >
                  <div
                    className="absolute inset-[8.333%]"
                    data-name="Vector"
                    id="node-I93_3633-16_3594"
                  >
                    <img
                      alt=""
                      aria-hidden="true"
                      className="block max-w-none size-full"
                      src={img}
                    />
                  </div>
                </div>
              ))}
            <div
              className="font-['SF_Pro_Display:Semibold',_sans-serif] leading-[0] not-italic relative shrink-0 text-[16px] text-nowrap text-white"
              data-node-id="93:3634"
            >
              <p className="leading-[1.3] whitespace-pre">{label}</p>
            </div>
            {rightIcon &&
              (rightIcon1 || (
                <div
                  className="overflow-clip relative shrink-0 size-6"
                  data-name="Icon"
                  data-node-id="93:3635"
                >
                  <div
                    className="absolute inset-[8.333%]"
                    data-name="Vector"
                    id="node-I93_3635-16_3594"
                  >
                    <img
                      alt=""
                      aria-hidden="true"
                      className="block max-w-none size-full"
                      src={img}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="absolute inset-0 pointer-events-none shadow-[0px_8px_16px_0px_inset_rgba(255,255,255,0.16),0px_2px_0px_0px_inset_rgba(255,255,255,0.1)]" />
        <div
          aria-hidden
          className="absolute border border-blue-600 border-solid inset-[-1px] pointer-events-none rounded-[13px] shadow-[0px_1px_1px_0.05px_rgba(24,24,27,0.24)]"
        />
      </button>
    )
  }
  if (size === 'Large' && style === 'Tertiary' && state === 'Active') {
    return (
      <button
        type="button"
        className="bg-secondary text-foreground box-border content-stretch flex gap-2 items-center justify-center px-5 py-3 relative rounded-[12px] size-full cursor-pointer"
        onClick={onClick}
        data-name="Size=Large, Style=Tertiary, State=Active"
        data-node-id="93:3641"
      >
        <div
          className="content-stretch flex gap-2 items-center justify-center relative shrink-0"
          data-name="Block"
          data-node-id="93:3642"
        >
          {leftIcon &&
            (leftIcon1 || (
              <div
                className="overflow-clip relative shrink-0 size-6"
                data-name="Icon"
                data-node-id="93:3643"
              >
                <div
                  className="absolute inset-[8.333%]"
                  data-name="Vector"
                  id="node-I93_3643-16_3594"
                >
                  <img
                    alt=""
                    aria-hidden="true"
                    className="block max-w-none size-full"
                    src={img1}
                  />
                </div>
              </div>
            ))}
          <div
            className="font-['SF_Pro_Display:Semibold',_sans-serif] leading-[0] not-italic relative shrink-0 text-[16px] text-nowrap text-foreground"
            data-node-id="93:3644"
          >
            <p className="leading-[1.3] whitespace-pre">{label}</p>
          </div>
          {rightIcon &&
            (rightIcon1 || (
              <div
                className="overflow-clip relative shrink-0 size-6"
                data-name="Icon"
                data-node-id="93:3645"
              >
                <div
                  className="absolute inset-[8.333%]"
                  data-name="Vector"
                  id="node-I93_3645-16_3594"
                >
                  <img
                    alt=""
                    aria-hidden="true"
                    className="block max-w-none size-full"
                    src={img1}
                  />
                </div>
              </div>
            ))}
        </div>
      </button>
    )
  }
  if (size === 'Large' && style === 'Tertiary' && state === 'Focused') {
    return (
      <button
        type="button"
        className="bg-white text-foreground box-border content-stretch flex gap-2 items-center justify-center overflow-clip px-5 py-3 relative rounded-[12px] shadow-[0px_0px_0px_1px_#bfdbfe,0px_0px_0px_4px_#eff6ff,0px_1px_1px_0.5px_rgba(24,24,27,0.05)] size-full cursor-pointer"
        onClick={onClick}
        data-name="Size=Large, Style=Tertiary, State=Focused"
        data-node-id="93:3646"
      >
        <div
          className="content-stretch flex gap-2 items-center justify-center relative shrink-0"
          data-name="Block"
          data-node-id="93:3647"
        >
          {leftIcon &&
            (leftIcon1 || (
              <div
                className="overflow-clip relative shrink-0 size-6"
                data-name="Icon"
                data-node-id="93:3643"
              >
                <div
                  className="absolute inset-[8.333%]"
                  data-name="Vector"
                  id="node-I93_3643-16_3594"
                >
                  <img
                    alt=""
                    aria-hidden="true"
                    className="block max-w-none size-full"
                    src={img1}
                  />
                </div>
              </div>
            ))}
          <div
            className="font-['SF_Pro_Display:Semibold',_sans-serif] leading-[0] not-italic relative shrink-0 text-[16px] text-nowrap text-foreground"
            data-node-id="93:3644"
          >
            <p className="leading-[1.3] whitespace-pre">{label}</p>
          </div>
          {rightIcon &&
            (rightIcon1 || (
              <div
                className="overflow-clip relative shrink-0 size-6"
                data-name="Icon"
                data-node-id="93:3645"
              >
                <div
                  className="absolute inset-[8.333%]"
                  data-name="Vector"
                  id="node-I93_3645-16_3594"
                >
                  <img
                    alt=""
                    aria-hidden="true"
                    className="block max-w-none size-full"
                    src={img1}
                  />
                </div>
              </div>
            ))}
        </div>
      </button>
    )
  }
  // Default: Large Primary Focused
  return (
    <button
      type="button"
      className="bg-blue-500 text-white relative rounded-[12px] size-full cursor-pointer"
      onClick={onClick}
      data-name="Size=Large, Style=Primary, State=Focused"
      data-node-id="93:3636"
    >
      <div className="box-border content-stretch flex gap-2 items-center justify-center overflow-clip px-5 py-3 relative size-full">
        <div
          className="content-stretch flex gap-2 items-center justify-center relative shrink-0"
          data-name="Block"
          data-node-id="93:3637"
        >
          {leftIcon &&
            (leftIcon1 || (
              <div
                className="overflow-clip relative shrink-0 size-6"
                data-name="Icon"
                data-node-id="93:3633"
              >
                <div
                  className="absolute inset-[8.333%]"
                  data-name="Vector"
                  id="node-I93_3633-16_3594"
                >
                  <img alt="" aria-hidden="true" className="block max-w-none size-full" src={img} />
                </div>
              </div>
            ))}
          <div
            className="font-['SF_Pro_Display:Semibold',_sans-serif] leading-[0] not-italic relative shrink-0 text-[16px] text-nowrap text-white"
            data-node-id="93:3634"
          >
            <p className="leading-[1.3] whitespace-pre">{label}</p>
          </div>
          {rightIcon &&
            (rightIcon1 || (
              <div
                className="overflow-clip relative shrink-0 size-6"
                data-name="Icon"
                data-node-id="93:3635"
              >
                <div
                  className="absolute inset-[8.333%]"
                  data-name="Vector"
                  id="node-I93_3635-16_3594"
                >
                  <img alt="" aria-hidden="true" className="block max-w-none size-full" src={img} />
                </div>
              </div>
            ))}
        </div>
      </div>
      <div
        aria-hidden
        className="absolute border border-blue-600 border-solid inset-[-1px] pointer-events-none rounded-[13px] shadow-[0px_0px_0px_1px_#d6f2fe,0px_0px_0px_4px_#f3fbff,0px_1px_1px_0.5px_rgba(24,24,27,0.05)]"
      />
    </button>
  )
}

export default Button
